import { CDN_API } from '../axios-instance'

export const getEtag = async () => {
  return await CDN_API.head('/', {
    baseURL: '',
    headers: {
      Accept: 'text/html',
    },
  }).then(data => data.headers['etag'] as string)
}
